const middleware = {}

middleware['browser-valid'] = require('../middleware/browser-valid.js')
middleware['browser-valid'] = middleware['browser-valid'].default || middleware['browser-valid']

middleware['is-mobile'] = require('../middleware/is-mobile.js')
middleware['is-mobile'] = middleware['is-mobile'].default || middleware['is-mobile']

export default middleware
